export default "__VITE_ASSET__282fedc9__"